import { primitiveColorTokens, primitiveFontTokens, primitiveLayoutTokens } from "./primitive";

const { blue, shade } = primitiveColorTokens;

export const semanticTokens = {
    primary: {
        50: "{blue.50}",
        100: "{blue.100}",
        200: "{blue.200}",
        300: "{blue.300}",
        400: "{blue.400}",
        500: blue["450"],
        600: "{blue.600}",
        700: "{blue.700}",
        800: "{blue.800}",
        900: "{blue.900}",
        950: "{blue.950}",
    },
    shade: primitiveColorTokens.shade,
    colorScheme: {
        light: {
            surface: {
                0: shade[0],
                50: shade[50],
                100: shade[100],
                200: shade[200],
                300: shade[300],
                ground: shade[0],
                section: shade[50],
                card: shade[0],
                overlay: shade[0],
                border: shade[300],
            },
            azara: {
                blue: primitiveColorTokens.blue,
                green: primitiveColorTokens.green,
                orange: primitiveColorTokens.orange,
                red: primitiveColorTokens.red,
                pink: primitiveColorTokens.pink,
                yellow: primitiveColorTokens.yellow,
                purple: primitiveColorTokens.purple,
                grey: primitiveColorTokens.grey,
                white: primitiveColorTokens.white,
                brown: primitiveColorTokens.brown,
                transparent: primitiveColorTokens.transparent,
                translucentGrey: primitiveColorTokens.translucentGrey,
                translucentBlue: primitiveColorTokens.translucentBlue,
                fonts: primitiveFontTokens,
                layout: primitiveLayoutTokens,
            },
            formField: {
                borderColor: "{shade.300}",
                hoverBorderColor: primitiveColorTokens.blue[750],
                focusBorderColor: primitiveColorTokens.blue["750"],
                hoverBackground: primitiveColorTokens.blue["000"],
            },

            text: {
                color: primitiveColorTokens.grey[800],
                hoverColor: shade[950],
                mutedColor: shade[500],
                highlightBackground: blue["000"],
                highlightColor: shade[900],
            },
        },
    },
};
